import {
    GET_USER_ASSIGNMENTS_REQUEST,
    GET_USER_ASSIGNMENTS_SUCCESS,
    GET_USER_ASSIGNMENTS_FAILURE
} from '../actions';

const initialState = {
    data: [],
    page:1,
    hasMore:true
};

const GetUserAssignmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_ASSIGNMENTS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_USER_ASSIGNMENTS_SUCCESS:
            if(action.payload.length === 0){
                return Object.assign({},state,
                    {asyncStatus:  'SUCCESS',
                        data: [],
                        page: 1,
                        hasMore: false
                    });
            }
            if(action.flag === 0){
                state = initialState;
            }
            let newData= action.payload || [];
            if(state.data.results){
                newData["results"] = [...state.data.results,...action.payload.results];
            }
            return Object.assign({},state, {asyncStatus:  'SUCCESS',
                data: newData,
                hasMore:action.payload.nextPage !== -1,
                page: action.payload.currentPage
            });
        case GET_USER_ASSIGNMENTS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default GetUserAssignmentsReducer;